import { Hourglass } from 'lucide-react';

/**
 * Dashboard de perfis cujos módulos ainda não existem (Financeiro,
 * Gestão de projetos) — Fase 26e.
 */
export default function PlaceholderDashboard({ perfil }: { perfil: string }) {
  return (
    <div className="bg-surface border border-line rounded-2xl p-10 text-center">
      <div className="w-14 h-14 mx-auto rounded-2xl bg-canvas text-muted flex items-center justify-center mb-4">
        <Hourglass size={26} />
      </div>
      <h2 className="text-lg font-semibold text-fg">{perfil}</h2>
      <p className="text-sm text-muted mt-1 max-w-md mx-auto">
        O módulo deste perfil ainda está em desenvolvimento. Assim que estiver
        disponível, o dashboard aparecerá aqui automaticamente.
      </p>
    </div>
  );
}
